import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Lock, Crown } from '@phosphor-icons/react';
import { useSubscription, hasTier } from '../context/SubscriptionContext';

export default function TierGate({ requiredTier, feature, children }) {
  const { tier, loading } = useSubscription();
  const location = useLocation();

  if (loading) return null;
  if (hasTier(tier, requiredTier)) return children;

  const tierLabel = requiredTier === 'elite' ? 'Elite' : 'Pro';
  const tierColor = requiredTier === 'elite' ? '#FBBF24' : '#A855F7';

  return (
    <div className="w-full max-w-3xl mx-auto py-16 px-6" data-testid="tier-gate">
      <div className="bg-[#12141A] border p-12 text-center relative overflow-hidden" style={{ borderColor: `${tierColor}30` }}>
        <div
          className="absolute -top-20 -right-20 w-64 h-64 opacity-20 rounded-full blur-3xl"
          style={{ background: tierColor }}
        />
        <div className="relative">
          <div className="flex justify-center mb-6">
            {requiredTier === 'elite' ? (
              <Crown size={56} weight="duotone" style={{ color: tierColor }} />
            ) : (
              <Lock size={56} weight="duotone" style={{ color: tierColor }} />
            )}
          </div>
          <div className="text-xs font-mono uppercase tracking-[0.3em] mb-2" style={{ color: tierColor }}>
            {tierLabel} Feature
          </div>
          <h2 className="text-3xl font-heading font-black tracking-tighter text-white mb-3">
            {feature} is locked
          </h2>
          <p className="text-[#94A3B8] mb-8 max-w-md mx-auto">
            Upgrade to <span style={{ color: tierColor }}>{tierLabel}</span> to unlock this feature and many more advanced tools.
          </p>
          <Link
            to={`/pricing?target=${requiredTier}&from=${encodeURIComponent(location.pathname)}`}
            className="inline-block px-8 py-3 text-white font-medium transition-colors"
            style={{ background: tierColor }}
            data-testid="upgrade-cta"
          >
            View {tierLabel} Plans →
          </Link>
        </div>
      </div>
    </div>
  );
}
